import { useMemo, useState } from "react";

function FAQBot() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    {
      role: "bot",
      text: "Hi. Ask me simple questions like booking, payment, wallet, referral, delivery, or membership.",
    },
  ]);

  const faqMap = useMemo(
    () => [
      {
        keywords: ["booking", "book", "slot", "date"],
        answer:
          "You can choose service or material, add it to cart, then select date and slot during checkout.",
      },
      {
        keywords: ["wallet", "earning", "payout"],
        answer:
          "Worker and shop owner earnings are held in wallet and released on a weekly cycle every Saturday.",
      },
      {
        keywords: ["referral", "bonus", "refer"],
        answer:
          "Workers can refer other workers. After the referred worker completes 30 bookings, both may receive a dynamic bonus up to ₹3000 each.",
      },
      {
        keywords: ["cash", "cod"],
        answer:
          "If customer pays in cash, the service/platform fee can still be adjusted from the worker or shop owner wallet, even if the wallet becomes temporarily negative.",
      },
      {
        keywords: ["delivery", "material"],
        answer:
          "Material delivery charges are calculated during checkout based on slot, location, size, material type, and logistics suitability.",
      },
      {
        keywords: ["membership"],
        answer:
          "Membership gives controlled benefits such as pricing support and repeat-order value, depending on your plan.",
      },
      {
        keywords: ["language"],
        answer:
          "You can change your app language from the Settings page.",
      },
    ],
    []
  );

  const getBotReply = (text) => {
    const normalized = text.toLowerCase();

    const found = faqMap.find((item) =>
      item.keywords.some((keyword) => normalized.includes(keyword))
    );

    if (found) return found.answer;

    return "I can currently answer basic questions about booking, payments, wallet, referral, delivery, and membership.";
  };

  const handleSend = () => {
    const trimmed = input.trim();
    if (!trimmed) return;

    const botReply = getBotReply(trimmed);

    setMessages((prev) => [
      ...prev,
      { role: "user", text: trimmed },
      { role: "bot", text: botReply },
    ]);
    setInput("");
  };

  return (
    <div style={wrapper}>
      {open && (
        <div style={panel}>
          <div style={panelHeader}>
            <strong>Help Bot</strong>
            <button onClick={() => setOpen(false)} style={closeBtn}>
              ✕
            </button>
          </div>

          <div style={messagesBox}>
            {messages.map((msg, index) => (
              <div
                key={index}
                style={{
                  ...bubble,
                  alignSelf: msg.role === "user" ? "flex-end" : "flex-start",
                  background: msg.role === "user" ? "#fff" : "#111",
                  color: msg.role === "user" ? "#000" : "#fff",
                  border:
                    msg.role === "user"
                      ? "none"
                      : "1px solid #2a2a2a",
                }}
              >
                {msg.text}
              </div>
            ))}
          </div>

          <div style={inputRow}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask a question..."
              style={inputStyle}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSend();
              }}
            />
            <button onClick={handleSend} style={sendBtn}>
              Send
            </button>
          </div>
        </div>
      )}

      {!open && (
        <button onClick={() => setOpen(true)} style={fab}>
          💬
        </button>
      )}
    </div>
  );
}

const wrapper = {
  position: "fixed",
  right: "18px",
  bottom: "18px",
  zIndex: 2000,
};

const fab = {
  width: "56px",
  height: "56px",
  borderRadius: "50%",
  border: "none",
  background: "#fff",
  color: "#000",
  fontSize: "22px",
  cursor: "pointer",
  boxShadow: "0 8px 30px rgba(0,0,0,0.35)",
};

const panel = {
  width: "320px",
  background: "#000",
  border: "1px solid #2a2a2a",
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "0 10px 40px rgba(0,0,0,0.45)",
};

const panelHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 14px",
  borderBottom: "1px solid #1f1f1f",
  color: "#fff",
  background: "#0b0b0b",
};

const closeBtn = {
  border: "none",
  background: "transparent",
  color: "#fff",
  cursor: "pointer",
};

const messagesBox = {
  padding: "12px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  maxHeight: "320px",
  overflowY: "auto",
};

const bubble = {
  padding: "10px 12px",
  borderRadius: "12px",
  maxWidth: "85%",
  fontSize: "14px",
  lineHeight: "1.5",
};

const inputRow = {
  display: "flex",
  gap: "8px",
  padding: "12px",
  borderTop: "1px solid #1f1f1f",
};

const inputStyle = {
  flex: 1,
  padding: "10px 12px",
  borderRadius: "10px",
  border: "1px solid #2a2a2a",
  background: "#111",
  color: "#fff",
};

const sendBtn = {
  padding: "10px 12px",
  borderRadius: "10px",
  border: "none",
  background: "#fff",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer",
};

export default FAQBot;